module.exports = __webpack_public_path__ + "img/bg35.01dffb68.png";